import React, { useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import { Button } from "../../components/ui/forms/Button";
import { PatronContext } from "../../contexts/PatronContext";

export const DeletePatronModal = ({ open, close, patron }) => {
  const { selectPatron, deletePatron } = useContext(PatronContext);

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{`Delete ${patron.firstName} ${patron.lastName}?`}</DialogTitle>
      <DialogContent>
        This will permanently remove {patron.firstName} {patron.lastName} from
        the database.
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          onClick={() => {
            deletePatron(patron);
            selectPatron();
            close();
          }}
          colour="error"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
